"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachmentSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.attachmentSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['documentID'],
    properties: {
        acl: {
            type: ['array', 'null'],
            items: {
                type: 'string',
                errorMessage: 'should be a string',
            },
            errorMessage: 'should be an array of strings or null',
        },
        documentID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        metadata: {
            type: ['object', 'null'],
            additionalProperties: {
                not: true,
                /* eslint-disable-next-line no-template-curly-in-string */
                errorMessage: '- should not have additional property ${0#}',
            },
            required: ['description', 'fileName', 'fileSize'],
            properties: {
                description: {
                    type: 'string',
                    errorMessage: 'should be a string',
                },
                documentType: {
                    type: ['number', 'null'],
                    errorMessage: 'should be a number or null',
                },
                fileName: {
                    type: 'string',
                    errorMessage: 'should be a string',
                },
                fileSize: {
                    type: 'number',
                    errorMessage: 'should be a number',
                },
                uploadStatusCode: {
                    type: ['number', 'null'],
                    errorMessage: 'should be a number or null',
                },
            },
        },
        submitter: {
            type: ['object', 'null'],
            additionalProperties: {
                not: true,
                /* eslint-disable-next-line no-template-curly-in-string */
                errorMessage: '- should not have additional property ${0#}',
            },
            required: ['hbtUserID'],
            properties: {
                hbtUserID: {
                    type: 'string',
                    format: 'uuid',
                    errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
                },
                hbtUserType: {
                    type: ['number', 'null'],
                    enum: Object.values(constants_1.UserType),
                    errorMessage: 'Should equate to a valid UserType Enum value',
                },
                firstName: {
                    type: ['string', 'null'],
                    errorMessage: 'should be a string',
                },
                lastName: {
                    type: ['string', 'null'],
                    errorMessage: 'should be a string',
                },
            },
        },
    },
};
